import React, { useState, useEffect, useRef } from 'react';
import { fetchData } from './utils/api';

const WX_DATA_BASE_URL =
  import.meta.env.VITE_WX_DATA_BASE_URL || 'https://wx-data.willowcreeknm.com';

interface Status {
  soc: number;
  tin: number;
}

function AppFooter(): React.JSX.Element {
  const [status, setStatus] = useState<Status | null>(null);
  const statusId = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    async function getStatus() {
      const data = await fetchData<Status>(`${WX_DATA_BASE_URL}/status.json`, 'status');
      if (data) {
        setStatus(data);
      }
    }

    void getStatus();
    statusId.current = setInterval(() => {
      void getStatus();
    }, 30000); // runs every 30 seconds.

    return () => {
      if (statusId.current) {
        clearInterval(statusId.current);
      }
    };
  }, []);

  return (
    <div className="footer ps-4 pe-4">
      {status ? (
        <>
          {status.soc} / {status.tin}
        </>
      ) : (
        '--'
      )}
      <div style={{ float: 'right' }}>
        <a href="mailto:webmaster@willowcreeknm.com">webmaster@willowcreeknm.com</a>
      </div>
    </div>
  );
}

export default AppFooter;
